import { TagType } from '@/components/v3/tag';

/**
 * 巨幕Banner
 */
export type LargeBanner =  {
  /** 图片地址 */
  img: string,
  /** 跳转地址 */
  url: string,
  /** 投放计划id */
  id: number,
  /** 倒计时 */
  countdown: number,
  /** 回到首页文案颜色 */
  backBtnColor: string,
  /** bi扩展字段信息 */
  reportInfo?: any,
};

/**
 * 胶囊Banner
 */
export type MiniBanner =  {
  /** logo地址 */
  logo: string,
  /** 跳转地址 */
  url: string,
  /** 投放计划id */
  id: number,
  /** 描述 */
  desc: string,
  /** 标题 */
  title: string,
  /** 胶囊图片地址 */
  img: string,
  /** 按钮文案 */
  btnText: string,
  /** 胶囊Banner类型 */
  type: number,
  /** bi扩展字段信息 */
  reportInfo?: any,
};

/**
 * 热门优惠
 */
export type HotOffer =  {
  /** 图片地址 */
  img: string,
  /** 跳转地址 */
  url: string,
  /** 投放计划id */
  id: number,
  /** 标题 */
  title: string,
  /** 开始时间 */
  startTime: Date,
  /** 结束时间 */
  endTime: Date,
  /** 时间描述类型 */
  descTimeType: number,
  /** bi扩展字段信息 */
  reportInfo?: any,

  /** 小程序 appid */
  appid?: string,
  /** 小程序 username */
  username?: string,
  /** 小程序 path */
  path?: string,
};

export type Tag = {
  /** 文案 */
  text: string;
  /** 类型 */
  type: TagType;
};

/**
 * 热门资讯
 */
export type HotNews =  {
  /** 跳转地址 */
  url: string,
  /** 投放计划id */
  id: number,
  /** logo地址 */
  logo: string;
  /** 标题 */
  title: string;
  /** 描述 */
  desc: string;
  /** 标签 */
  tagList: Tag[];
  /** bi扩展字段信息 */
  reportInfo?: any,
};

// /**
//  * 首页投放位置枚举值
//  */
export enum HomeDpPositions {
  /** 巨幕banner */
  LargeBanner = '1100040000360002',
  /** 胶囊banner */
  MiniBanner = '1100040000360003',
  /** 热门优惠 */
  HotOffer = '1100040000360004',
  /** 热门资讯 */
  HotNews = '1100040000360005'
}

// 优惠券专区首页 - 投放页面
export const DP_PAGE = '110004000036';

